module.exports = __webpack_public_path__ + "b9c6083114d5a6294c87e5f8c90261c6.png";